import { useSelector } from 'react-redux';
import { exportTemplateSelectors as sel } from 'reducers/exportTemplate/reducer';
import { modalHeader as strings } from '../strings';
import {
  BreadcrumbLink,
  BreadcrumbText,
  ModalHeader,
  ParagraphGrey,
} from '../styled';
import { Icon } from 'components/common';

export const ExportTemplateModalHeader = ({ onBackPressed }) => {
  const modalView = useSelector(sel.modalView);
  const isEditDirty = useSelector(sel.isEditDirty);
  const isDraftDirty = useSelector(sel.isDraftDirty);
  const templateName = useSelector(sel.getEditingTemplateName);

  const draftSheetName = useSelector(sel.getDraftSheetName);

  const renderHeaderContents = () => {
    if (modalView === 'save') {
      return <BreadcrumbText>{strings.createExportTemplate}</BreadcrumbText>;
    }

    if (modalView === 'settings') {
      return <BreadcrumbText>{strings.templateSettings}</BreadcrumbText>;
    }

    if (draftSheetName) {
      return (
        <>
          <BreadcrumbLink onClick={onBackPressed}>
            <Icon icon='chevronLeft' size='1x' color={null} />
            {strings.customise(templateName)}
          </BreadcrumbLink>
          <BreadcrumbText>
            <Icon
              icon='chevronRight'
              size='xs'
              style={{ width: 10, height: 10 }}
              color={null}
            />
          </BreadcrumbText>
          <BreadcrumbText>{draftSheetName}</BreadcrumbText>
          <ParagraphGrey style={{ marginTop: 2, width: 300 }}>
            {isDraftDirty && strings.unsavedChanges}
          </ParagraphGrey>
        </>
      );
    }

    return (
      <>
        <BreadcrumbText>{strings.customise(templateName)}</BreadcrumbText>
        {isEditDirty && <ParagraphGrey>{strings.unsavedChanges}</ParagraphGrey>}
      </>
    );
  };

  return <ModalHeader>{renderHeaderContents()}</ModalHeader>;
};
